import React from 'react';
import { Box, Skeleton, Stack } from '@mui/material';

export default function LoadingState({
  rows = 6,
  header = true,
  card = true,
}) {
  return (
    <Box>
      {header ? <Skeleton variant="rounded" height={56} sx={{ mb: 1.6, borderRadius: 2 }} /> : null}
      <Stack spacing={1}>
        {Array.from({ length: rows }).map((_, index) => (
          <Skeleton key={index} variant="rounded" height={card ? 52 : 24} sx={{ borderRadius: 2 }} />
        ))}
      </Stack>
    </Box>
  );
}

